import {
  fieldDelete,
  fieldDrag,
  fieldImg,
  fieldReverse,
  fieldSetting,
  multiSelectQuestionIcon,
  picturePLaceholder,
  ratingStar,
  singleSelectedQuestionIcon,
} from "assets/icons";
import {
  Input,
  InputAreaAutoAdjust,
  RatingStar,
  SwitchButton,
  TextArea,
  TextAreaAutoAdjust,
} from "components/form";
import { surveyFormValue } from "constant/staticData";
import React, { useEffect, useRef, useState } from "react";
import { FaMinus, FaPlus, FaStar } from "react-icons/fa";
import { adjustOptions, isArray, isArrayEmpty } from "utils/commonHelper";
import { toastMessage } from "utils/toastMessageHelper";
import DeleteModal from "components/modals/DeleteModal";
import CustomModal from "components/modals/CustomModal";
import SurveyQuestionSettingValue from "./SurveyQuestionSettingValue";
import UploadImage from "./UploadImage";
import { RxCrossCircled } from "react-icons/rx";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { FaArrowDown, FaArrowUp } from "react-icons/fa6";
import SliderRatingSkipSurvey from "./SliderRatingSkipSurvey";
import { useTranslation } from "react-i18next";

const RatingQuestion = ({
  data,
  indexValue,
  selectedBlock,
  skipDropdownList,
  surveyQuestionArray,
  skipSurveySelectedQues,
  setSurveyQuestionArray,
  skipSurveyOnClickHandler,
  prevQuestionCount,
  blockArray,
  setBlockArray,
}) => {
  // Create a ref to focus on the last option input
  const lastOptionRef = useRef(null);

  // Rating value
  const [ratingValue, setRatingValue] = useState(4);
  const [skipSurveyModal, setSkipSurveyModal] = useState(false);

  const { t } = useTranslation();

  // set all value
  const [deleteQuestionModal, setDeleteQuestionModal] = useState(false);
  const [settingQuestionModal, setSettingQuestionModal] = useState(false);
  const [surveyQuestionImageModal, setSurveyQuestionImageModal] =
    useState(false);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: data?.questionNumber });

  const style = {
    transform: `translateY(${transform?.y || 0}px)`,
    transition,
    opacity: isDragging ? 0.7 : 1, // Change opacity when dragging
    boxShadow: isDragging ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none", // Add shadow when dragging
    cursor: isDragging ? "grabbing" : "grab", // Change cursor style
    background: isDragging ? "#f5f5f5" : "#fff", // Optional: Change background color
  };
  // function handler

  // Helper function to update the main surveyQuestionArray
  const updateSurveyArray = (updatedOptions) => {
    setSurveyQuestionArray((prevArray) => {
      const updatedArray = { ...prevArray };
      updatedArray[selectedBlock][indexValue].option = updatedOptions;
      return updatedArray;
    });
  };

  // Optimized onChange handler
  const onChangehandler = (e, field) => {
    const { value } = e?.target || {};
    setSurveyQuestionArray((prevArray) => {
      const updatedArray = { ...prevArray };
      updatedArray[selectedBlock][indexValue][field] = value;
      return updatedArray;
    });
  };

  const onStatusChangehandler = (e) => {
    const { checked } = e?.target || {};
    setSurveyQuestionArray((prevArray) => {
      const updatedArray = { ...prevArray };
      updatedArray[selectedBlock][indexValue]["required"] = checked;
      return updatedArray;
    });
  };

  // Handle option value change
  const handleOptionChange = (id, value) => {
    const updatedOptions = data?.option?.map((option) =>
      option.rank === id ? { ...option, optionValue: value } : option
    );
    updateSurveyArray(updatedOptions);
  };

  // Add a new option
  const addOption = (id = 0) => {
    if (data?.option?.length >= (surveyFormValue?.MAX_OPTION_LIMIT || 4)) {
      toastMessage(
        `${t(`CUSTOMIZATION_QUESTION.addMaxOption`)} ${
          surveyFormValue?.MAX_OPTION_LIMIT || 4
        } ${t(`CUSTOMIZATION_QUESTION.option`)}.`,
        "warning",
        "addOptionValue"
      );
      return;
    }
    const newOption = {
      optionValue: "",
      optionImage: "",
      questionNumber: "",
      rank: id + 1,
    };
    const updatedOptions = [...data?.option, newOption];
    updateSurveyArray(updatedOptions);
  };

  // Remove option
  const removeOption = (id) => {
    const updatedOptions = data?.option?.filter((option) => option.rank !== id);
    const adjustedOptions = adjustOptions("rank", updatedOptions);
    updateSurveyArray(adjustedOptions);
  };

  // Deleted Selected Survey

  const deletedSelectedQuestionHandler = () => {
    const selectedBlockArray = surveyQuestionArray[selectedBlock];
    if (
      isArray(surveyQuestionArray[selectedBlock]) &&
      Number.isInteger(indexValue) &&
      indexValue >= 0 &&
      indexValue < selectedBlockArray.length
    ) {
      let blockUpdatedClone = blockArray?.map((el) => el);
      let blockIndex = blockArray.findIndex((el) => el?.name === selectedBlock);

      blockUpdatedClone[blockIndex] = {
        ...blockUpdatedClone[blockIndex],
        totalQuestion: blockUpdatedClone[blockIndex]?.totalQuestion - 1,
      };

      setBlockArray(blockUpdatedClone);

      setSurveyQuestionArray((prevSurveyQuestionArray) => {
        const updatedSurveyArray = { ...prevSurveyQuestionArray };
        const updatedBlock = [...selectedBlockArray];
        updatedBlock.splice(indexValue, 1);
        const adjustedSurveyQuestion = adjustOptions(
          "questionNumber",
          updatedBlock
        );
        updatedSurveyArray[selectedBlock] = adjustedSurveyQuestion;
        return updatedSurveyArray;
      });
    }
    closeModal();
  };

  // handle delete Selected Photo handler
  const deletedSelectedPicHandler = () => {
    const selectedBlockArray = surveyQuestionArray[selectedBlock];
    if (
      isArray(surveyQuestionArray[selectedBlock]) &&
      Number.isInteger(indexValue) &&
      indexValue >= 0 &&
      indexValue < selectedBlockArray.length
    ) {
      setSurveyQuestionArray((prevSurveyQuestionArray) => {
        const updatedSurveyArray = { ...prevSurveyQuestionArray };
        const updatedBlock = [...selectedBlockArray];
        updatedBlock[indexValue].questionImage = "";
        updatedSurveyArray[selectedBlock] = updatedBlock;
        return updatedSurveyArray;
      });
    }
  };

  // close modal
  const closeModal = () => {
    setSkipSurveyModal(false);
    setDeleteQuestionModal(false);
    setSettingQuestionModal(false);
    setSurveyQuestionImageModal(false);
  };

  // const style = {
  //   transform: CSS.Transform.toString(transform),
  //   transition,
  // };

  // Set the focus after the option is added
  useEffect(() => {
    if (data?.option?.length > 0 && lastOptionRef.current) {
      lastOptionRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center", // Ensure it's centered in the viewport
        inline: "nearest",
      });
    }
  }, [data?.option?.length]);

  const classNameHandler = () => {
    const { option } = data;
    let isSkipData = option.some((el) => el?.condValue) || false;

    if (isSkipData) {
      return "image_green";
    } else {
      return "";
    }
  };

  return (
    <>
      <div
        className="fields_wrap rating_field"
        // ref={setNodeRef}
        ref={setNodeRef}
        // onClick={(e) => e.stopPropagation()}
        style={style}
      >
        <div className="control_section">
          <div className="text">
            <span className="starRating">
              {data?.questionNumber + prevQuestionCount}{" "}
              <img src={ratingStar} alt={`${data?.questionNumber}-rating`} />
            </span>
            <b>
              {t(`CUSTOMIZATION_QUESTION.ratingChoice`)}
              {/* <font color={"red"}>*</font> */}
            </b>
          </div>
          <div className="control_button">
            {/*----------------------- Handler Skip Logic code area ------------------*/}
            <button
              type="button"
              title={t(`CUSTOMIZATION_QUESTION.skipQuestion`)}
              onClick={() => skipSurveyOnClickHandler(data, setSkipSurveyModal)}
            >
              <img
                alt=""
                src={fieldReverse}
                className={classNameHandler(data)}
              />
            </button>
            <button
              type="button"
              onClick={() => setSurveyQuestionImageModal(true)}
              title="Question Image"
            >
              <img src={fieldImg} alt="" />
            </button>
            <button
              type="button"
              title={t(`CUSTOMIZATION_QUESTION.questionSetting`)}
              onClick={() => setSettingQuestionModal(true)}
            >
              <img src={fieldSetting} alt="" />
            </button>
            <button
              type="button"
              title={t(`CUSTOMIZATION_QUESTION.questionDelete`)}
              onClick={() => setDeleteQuestionModal(true)}
            >
              <img src={fieldDelete} alt="" />
            </button>
            <button
              type="button"
              className="drag_icon"
              {...listeners}
              {...attributes}
            >
              <img src={fieldDrag} alt="" />
            </button>
          </div>
        </div>
        <div className="input_field">
          <TextAreaAutoAdjust
            name="question"
            style={{ resize: "none" }}
            value={data?.question || ""}
            placeholder={t(`CUSTOMIZATION_QUESTION.typeQuestionHere`)}
            onChange={(e) => onChangehandler(e, "question")}
            maxLength={surveyFormValue?.MAX_TEXT_AREA_LIMIT || 500}
          />
          <span className="text_count">{`${data?.question?.length || 0}/${
            surveyFormValue?.MAX_TEXT_AREA_LIMIT || 500
          }`}</span>
        </div>
        {data?.questionImage && (
          <div className="question_image">
            <img
              src={data?.questionImage || picturePLaceholder}
              alt="question file"
            />
            <span onClick={deletedSelectedPicHandler} className="close_button">
              <RxCrossCircled />
            </span>
          </div>
        )}
        <div className="multiSelect cstm_multiselect">
          {/* <div className="multiSelect"> */}
          {!isArrayEmpty(data?.option) &&
            data?.option.map((option, idx) => (
              <div key={`${option.rank}-${idx}`} className="input_field_wrap">
                <div className="input_field">
                  <InputAreaAutoAdjust
                    style={{ resize: "none" }}
                    value={option.optionValue}
                    placeholder={`${t(`CUSTOMIZATION_QUESTION.Option`)}-${
                      idx + 1
                    }`}
                    onChange={(e) =>
                      handleOptionChange(option.rank, e.target.value)
                    }
                    maxLength={surveyFormValue?.OPTION_VALUE_LIMIT || 200}
                    ref={idx === data.option.length - 1 ? lastOptionRef : null} // Focus on the last option
                  />
                  <span className="text_count">{`${
                    option?.optionValue?.length
                  }/${surveyFormValue?.OPTION_VALUE_LIMIT || 200}`}</span>
                  {/* <div className="wrap_arrow">
                      <FaArrowUp className=" cstm_arrow uparrow" />
                      <FaArrowDown className="cstm_arrow downarrow" />
                    </div> */}
                </div>
                <div className="star">
                  <RatingStar
                    readonly={true}
                    rating={data?.setting?.starCount || 5}
                    ratingValue={data?.setting?.starCount || 5}
                  />
                </div>
                <div className="add_button_wrap">
                  {data?.option.length > 1 &&
                    idx !== data?.option.length - 1 && (
                      <button
                        type="button"
                        disabled={data?.option?.length === 1}
                        onClick={() => removeOption(option.rank)}
                        className={data?.option?.length === 1 ? "disabled" : ""}
                      >
                        <FaMinus />
                      </button>
                    )}
                  {idx !== surveyFormValue?.MAX_OPTION_LIMIT - 1 &&
                    idx === data?.option.length - 1 && (
                      <>
                        <button
                          type="button"
                          disabled={data?.option?.length === 1}
                          onClick={() => removeOption(option.rank)}
                          className={
                            data?.option?.length === 1 ? "disabled" : ""
                          }
                        >
                          <FaMinus />
                        </button>
                        <button
                          type="button"
                          onClick={() => addOption(option.rank)}
                        >
                          <FaPlus />
                        </button>
                      </>
                    )}
                </div>
              </div>
            ))}
          {/* </div> */}
        </div>
        <div className="required__button_field">
          <span className="green">{t(`CUSTOMIZATION_QUESTION.required`)}</span>
          <SwitchButton
            status={data?.required || false}
            onChange={onStatusChangehandler}
          />
        </div>
      </div>
      {/* Delete Selected Modal */}
      {deleteQuestionModal && (
        <DeleteModal
          show={deleteQuestionModal}
          handleClose={closeModal}
          deleteHandler={deletedSelectedQuestionHandler}
          title={`${t(`CUSTOMIZATION_QUESTION.surveyDeleteQuestion`)} ${
            data?.questionNumber + prevQuestionCount
          }?`}
        />
      )}

      {/* Survey Setting Model */}
      {settingQuestionModal && (
        <CustomModal
          className={""}
          handleClose={closeModal}
          show={settingQuestionModal}
        >
          <SurveyQuestionSettingValue
            data={data}
            title={t(`CUSTOMIZATION_QUESTION.ratingChoice`)}
            indexValue={indexValue}
            handleClose={closeModal}
            selectedBlock={selectedBlock}
            setSurveyQuestionArray={setSurveyQuestionArray}
          />
        </CustomModal>
      )}

      {/* Upload Question Image */}
      {surveyQuestionImageModal && (
        <CustomModal
          show={surveyQuestionImageModal}
          handleClose={closeModal}
          className={""}
          closeButton={false}
        >
          <UploadImage
            type={"question"}
            data={data}
            handleClose={closeModal}
            indexValue={indexValue}
            setSurveyQuestionArray={setSurveyQuestionArray}
            selectedBlock={selectedBlock}
          />
        </CustomModal>
      )}

      {/* Skip Survey Modal */}
      {skipSurveyModal && (
        <CustomModal
          className={"xl"}
          closeButton={true}
          show={skipSurveyModal}
          handleClose={closeModal}
        >
          <SliderRatingSkipSurvey
            indexValue={indexValue}
            handleClose={closeModal}
            selectedBlock={selectedBlock}
            skipDropdownList={skipDropdownList}
            selectedQues={skipSurveySelectedQues}
            surveyQuestionArray={surveyQuestionArray}
            setSurveyQuestionArray={setSurveyQuestionArray}
          />
        </CustomModal>
      )}
    </>
  );
};

export default RatingQuestion;
